import GameLimits from './GameLimits';
export default GameLimits;